import { createFileRoute } from '@tanstack/react-router'

import { anyOfPermissions } from '@orus.eu/right-access-management'

import { SearchDocumentationPage } from '../../../../components/pages/backoffice/platform/platform-documentation/search-documentation-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/documentation/search')({
  component: () => (
    <PermissionChecker requiredPermissions={[anyOfPermissions('search', 'search.allowedOnly')]}>
      <SearchDocumentationPage />
    </PermissionChecker>
  ),
})
